import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";
Vue.use(VueRouter);

const routes = [
    //首页
    {
        path: "/",
        name: "Home",
        component: Home,
    },
];

const router = new VueRouter({
    mode: "history",
    //   base: process.env.BASE_URL,
    routes,
});

export default router;